"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const pie_chart_report_model_1 = require("./pie-chart-report.model");
const pie_chart_options_model_1 = require("./pie-chart-options.model");
class PieChartModel {
    constructor(chartReportModel, chartOptions, filter, reportOptions) {
        this._pages = [];
        this._pieChartReportModel = (chartReportModel || new pie_chart_report_model_1.PieChartReportModel());
        this._pieChartOptions = (chartOptions || new pie_chart_options_model_1.PieChartOptions());
        this._filterTreeDto = (filter || idm_reporting_service_client_js_1.FilterDtoBuilder.createOrFilterBuilder().build());
        this._reportOptions = (reportOptions || new idm_reporting_service_client_js_1.ReportOptions());
    }
    getPieChartReportModel() {
        return this.pieChartReportModel;
    }
    getPieChartOptions() {
        return this.pieChartOptions;
    }
    getFilter() {
        return this.filterTreeDto;
    }
    getReportOptions() {
        return this.reportOptions;
    }
    get pages() {
        return this._pages;
    }
    set pages(value) {
        this._pages = value;
    }
    toJsonString() {
        let toJsonData = "";
        toJsonData += "{";
        toJsonData += "\"pieChartReportModel\":";
        toJsonData += this.pieChartReportModel.toJson();
        toJsonData += ",";
        toJsonData += "\"filter\":";
        toJsonData += this.filterTreeDto.toJson();
        toJsonData += ",";
        toJsonData += "\"pieChartOptions\":";
        toJsonData += this.pieChartOptions.toJsonString();
        toJsonData += ",";
        toJsonData += "\"reportOptions\":";
        toJsonData += this.reportOptions.toJson();
        toJsonData += ",";
        toJsonData += "\"pages\":";
        toJsonData += "[";
        let pagesLength = this.pages.length;
        for (let i = 0; i < pagesLength; ++i) {
            if (i !== 0) {
                toJsonData += ",";
            }
            toJsonData += this.pages[i];
        }
        toJsonData += "],";
        toJsonData += "\"version\":";
        toJsonData += "\"" + PieChartModel.version + "\"";
        toJsonData += "}";
        return toJsonData;
    }
    /**
     * Deserializes the pie chart model from json string.
     * When we have empty page with new chart control, state is equal to "" or null.
     * @param {string} pieChartModel
     */
    fromJsonString(pieChartModel) {
        if (pieChartModel !== "" && pieChartModel !== null) {
            let pieChartModelJson = JSON.parse(pieChartModel);
            if (!pieChartModelJson.version || (pieChartModelJson.version === PieChartModel.version)) {
                this.pieChartReportModel.fromJson(pieChartModelJson.pieChartReportModel);
                this.pieChartOptions.fromJson(pieChartModelJson.pieChartOptions);
                this.reportOptions = idm_reporting_service_client_js_1.ReportOptions.fromJson(JSON.stringify(pieChartModelJson.reportOptions));
                this.filterTreeDto = idm_reporting_service_client_js_1.FilterTreeDto.fromJson(JSON.stringify(pieChartModelJson.filter));
                this.pages = pieChartModelJson.pages == undefined ? null : pieChartModelJson.pages;
            }
        }
    }
    get reportOptions() {
        return this._reportOptions;
    }
    set reportOptions(value) {
        this._reportOptions = value;
    }
    get filterTreeDto() {
        return this._filterTreeDto;
    }
    set filterTreeDto(value) {
        this._filterTreeDto = value;
    }
    get pieChartOptions() {
        return this._pieChartOptions;
    }
    set pieChartOptions(value) {
        this._pieChartOptions = value;
    }
    get pieChartReportModel() {
        return this._pieChartReportModel;
    }
    set pieChartReportModel(value) {
        this._pieChartReportModel = value;
    }
}
PieChartModel.version = "0.0.1";
exports.PieChartModel = PieChartModel;
//# sourceMappingURL=pie-chart.model.js.map